import { create } from 'zustand'
import { normalizeWebExclusionValue } from '@/utils/webCaptureSettings'

interface WebExclusionState {
  values: string[]
  addValues: (values: string[]) => void
  removeValue: (value: string) => void
  setValues: (values: string[]) => void
}

export const useWebExclusionStore = create<WebExclusionState>(set => ({
  values: [],
  addValues: values =>
    set(state => ({
      values: Array.from(
        new Set([
          ...state.values,
          ...values.map(normalizeWebExclusionValue).filter(Boolean),
        ])
      ),
    })),
  removeValue: value =>
    set(state => ({
      values: state.values.filter(
        item => item !== normalizeWebExclusionValue(value)
      ),
    })),
  setValues: values =>
    set({
      values: Array.from(
        new Set(values.map(normalizeWebExclusionValue).filter(Boolean))
      ),
    }),
}))
